import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b9e61690"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "inline-block h-screen align-middle",
  "aria-hidden": "true"
}, " ​ ", -1))

import { watch, ref, computed, shallowRef } from "vue";
import { useStore } from "vuex";
import { TransitionRoot, TransitionChild, Dialog, DialogOverlay } from "@headlessui/vue";
import ScanModal from "../../components/modal/scan-modal/ScanModal.vue";
import { MODALS } from "@/utils";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const modalsByName = {};
modalsByName[MODALS.ScanModal] = ScanModal;


const defaultCSSvalues = {
  width: "700px",
  height: "auto",
  backgroundColor: "white",
  position: "",
  top: "",
  left: ""
};

const store = useStore();
const currentModal = shallowRef(computed(() => store.getters[`modals/getCurrentModal`]));
const isOpen = ref(false);
const modalComponent = shallowRef(null);
const modalProps = ref(null);
const modalParams = ref(null);
const isUpFromBottomInMobile = ref(null);
const styles = computed(() => {
  return {
    "max-width": getParam(modalParams.value?.width, defaultCSSvalues.width),
    "max-height": getParam(modalParams.value?.height, defaultCSSvalues.height),
    position: getParam(modalParams.value?.position, defaultCSSvalues.position),
    top: getParam(modalParams.value?.top, defaultCSSvalues.top),
    left: getParam(modalParams.value?.left, defaultCSSvalues.left),
    background: modalParams.value?.background || defaultCSSvalues.backgroundColor,
    "border-radius": modalParams.value?.alwaysShowBoarderRadius ? "20px" : ""
  };
});

const modalOpenElement = shallowRef<HTMLElement>();
const keyUpElement = shallowRef<HTMLElement>();

const setSelectElement = event => {
  keyUpElement.value = event.target;
};

document.addEventListener("mouseup", setSelectElement);
document.addEventListener("keyup", setSelectElement);

/**
 * checks for valid CSS value, if none returns default.
 * @param {string|number} param
 * @param {string} defaultValue
 */
const getParam = (param: string | number, defaultValue: string): string => {
  if (!param) return defaultValue;
  if (typeof param === "number") return `${param}px`;
  return param;
};

/**
 * Calls modal close method
 */
const closeModal = () => {
  modalOpenElement.value?.focus();
  isOpen.value = false;
};

/**
 * Shows/hides the current modal set in state
 */
const showModal = async () => {
  modalOpenElement.value = keyUpElement.value;
  const { modalComp, props, params } = currentModal.value.modal;
  isUpFromBottomInMobile.value = props?.isUpFromBottomInMobile || false;
  modalComponent.value = typeof modalComp === "string" ? modalsByName[modalComp] : modalComp;
  modalProps.value = props;
  modalParams.value = params;
  isOpen.value = true;
};
/**
 * watches currentModal from store state, when updated will
 * open or close as needed.
 */
watch(
  () => currentModal.value,
  () => {
    if (currentModal.value.showModal) {
      showModal();
      return;
    }
    closeModal();
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    appear: "",
    show: isOpen.value,
    as: "template"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        onClose: closeModal
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              id: "modal-component-container",
              class: _normalizeClass([{ 'up-from-bottom-mobile': isUpFromBottomInMobile.value }, 'min-h-screen text-center'])
            }, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "duration-300 ease-out",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "duration-300 ease-in",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 overlay opacity-0" })
                ]),
                _: 1
              }),
              _hoisted_2,
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "duration-300 ease-out",
                "enter-from": "opacity-0 scale-90",
                "enter-to": "opacity-100 scale-100",
                leave: "duration-300 ease-in",
                "leave-from": "opacity-100 scale-100",
                "leave-to": "opacity-0 scale-90"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    style: _normalizeStyle(_unref(styles)),
                    class: "inline-block w-full max-w-md max-width overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl modal-border opacity-0 scale-90 modal-container"
                  }, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(modalComponent)), _normalizeProps(_guardReactiveProps(modalProps.value)), null, 16))
                  ], 4)
                ]),
                _: 1
              })
            ], 2)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})